'use client'

import { SheetHead } from '@/features/veluvit/components/overlay/layer-parts'
import { GemIcon } from '@/features/veluvit/components/ui/currency-icon'
import EmptyState from '@/features/veluvit/components/ui/empty-state'
import { fmt } from '@/features/veluvit/lib/format'
import { useSessionStore } from '@/features/veluvit/stores/session.store'

/** 충전·사용 내역 — 서버 원장 그대로 (v2 ACT.history) */
export default function HistorySheet() {
  const walletEntries = useSessionStore((state) => state.data?.wallet.entries)
  const entries = walletEntries ?? []
  return (
    <>
      <SheetHead title="충전·사용 내역" />
      {entries.length === 0 && (
        <EmptyState
          compact
          title="아직 젬 사용 내역이 없어요"
          description="젬을 충전하거나 사용하면 이곳에 기록돼요."
        />
      )}
      {entries.map((entry) => (
        <div
          key={entry.id}
          className="mt-2 rounded-field bg-foreground/[0.05] px-3 py-2.5"
        >
          <div className="flex items-center justify-between text-c13h">
            <span>{entry.reason}</span>
            <b className="inline-flex items-center gap-0.5 tabular-nums">
              <GemIcon />
              {entry.amount > 0 ? '+' : ''}
              {fmt(entry.amount)}
            </b>
          </div>
          <p className="text-c12 text-t3">
            {new Date(entry.createdAt).toLocaleString('ko-KR')}
          </p>
        </div>
      ))}
    </>
  )
}
